<script setup lang="ts">
import { accountService } from '@/api/services/account-service'
import { useIsMobile } from '@/composables/useMediaQuery'
import type { PaymentHistory } from '@/types/account.types'
import { onMounted, ref } from 'vue'
import PaymentListItem from './PaymentListItem.vue'

const paymentHistoryList = ref<PaymentHistory[]>([])

const isMobile = useIsMobile()

onMounted(async () => {
  const paymentHistoryCursor = await accountService.getPaymentHistory(null, 10, false)
  paymentHistoryList.value = paymentHistoryCursor.data
})
</script>

<template>
  <div class="my-view-payment-info">
    <div class="my-view-payment-info-title title-md white" :class="{ 'title-sm': isMobile }">
      결제내역
    </div>

    <div class="payment-list">
      <PaymentListItem v-for="item in paymentHistoryList" :key="item.idx" :item="item" />
    </div>

    <!-- 결과가 없는 경우 -->
    <div v-if="paymentHistoryList.length === 0" class="empty-state">
      <div class="empty-state-container">
        <div class="empty-state-icon-image">
          <img src="@/assets/svgs/cloud.svg" alt="empty-state-icon" />
        </div>
        <div class="empty-state-icon-text">
          <div class="title-sm white" :class="{ 'body-md': isMobile }">결제내역이 없습니다.</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.my-view-payment-info {
  color: white;
}

.my-view-payment-info-title {
  margin-bottom: 16px;
  display: inline-block;
}

.payment-list {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.empty-state {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  min-height: 380px;
}

.empty-state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
</style>
